<ppl-app-container>
  <div class="align-in-center">
    <ppl-box-container-with-header
      title="New Password"
      i18n-title="@@New_Password">
      @if (error$ | async; as error) {
        <ppl-error-box>
          @switch (error) {
            @case (PasswordResetError.ERROR_SESSION_EXPIRED) {
              <ng-container i18n="@@This_link_is_not_valid_anymore.">This link is not valid anymore.</ng-container>
            }
            @case (PasswordResetError.ERROR_INVALID_MESSAGE) {
              <ng-container i18n="@@Invalid_request_data_sent.">Invalid request data sent.</ng-container>
            }
            @case (PasswordResetError.ERROR_INCORRECT_LOGIN) {
              <ng-container i18n="@@Invalid_password.">Invalid password.</ng-container>
            }
            @default {
              <span i18n="@@Unknown_error.">Unknown error.</span>
            }
          }
        </ppl-error-box>
      }

      <ppl-form-container [formGroup]="form">
        <ppl-form-row>
          <ppl-form-column>
            <ppl-input-container
              label="Password"
              i18n-label="@@Password"
              [pplFormControl]="form.get('password1')">
              <input
                pplInput
                type="password"
                name="password1"
                autocomplete="new-password"
                formControlName="password1"
                (keyup)="onKeyUp($event)" />
            </ppl-input-container>
            <ppl-input-container
              label="Confirm password"
              i18n-label="@@Confirm_password"
              [pplFormControl]="form.get('password2')">
              <input
                pplInput
                type="password"
                name="password2"
                autocomplete="new-password"
                formControlName="password2"
                (keyup)="onKeyUp($event)" />
            </ppl-input-container>
          </ppl-form-column>
        </ppl-form-row>
      </ppl-form-container>

      <div class="buttons">
        <button
          pplButton
          pplButton2
          i18n="@@Change_password"
          (click)="onChangePassword()">
          Change password
        </button>
      </div>

      @if (resetting$ | async) {
        <ppl-loading-overlay
          [large]="true"
          [visible]="true"
          [inverse]="true"></ppl-loading-overlay>
      }
    </ppl-box-container-with-header>
  </div>
</ppl-app-container>
